export default __webpack_public_path__ + "static/media/StarFilled.44129b40.svg";